import React, { useCallback, useEffect, useState } from 'react';
import { compose, withReduxStore } from '@beef/redux';
import { safeLazy, withDataConverter } from '@beef/react';
import { HeaderModule, HeaderPromoRC, HeaderRC, headerDataConverter } from '@carnica/smart-kit';
import type { IHeaderCommon } from '@carnica/smart-kit';
import classNames from 'classnames/bind';
// @ts-expect-error FIXME need @beef/elk-shared .d.ts
import { SideMenu } from '@beef/elk-shared';

import { headerStore2024 } from 'store';

import { useBasket } from './hooks/useBasket';
import { useSentry } from './hooks/useSentry';
import { useLegacyHeaderActions } from './hooks/useLegacyHeaderActions';
import styles from './styles.pcss';

const cn = classNames.bind(styles);

const selectHeaderData = (state: any) => state.header;

const ChatWidgetLazy = safeLazy<Record<string, any>>(() =>
  import('widgets/Chat').then((module) => ({ default: module.ChatWidget })),
);

const HeaderV2 = ({ data }: { data: IHeaderCommon }) => {
  useLegacyHeaderActions(data);
  useSentry();
  useBasket(data.currentRegion);

  const [isOpenSideMenu, setIsOpenSideMenu] = useState(false);
  const [isFirstRender, setIsFirstRender] = useState(false);

  useEffect(() => {
    setIsFirstRender(true);
  }, []);

  const handleLoginClick = useCallback(() => {
    if (isOpenSideMenu) {
      document.body.classList.remove(cn('remove-y-hidden'));
    } else {
      document.body.classList.add(cn('remove-y-hidden'));
    }
    setIsOpenSideMenu((prev: boolean) => !prev);
  }, [isOpenSideMenu]);

  return (
    <>
      <HeaderModule onLoginClick={handleLoginClick} selectData={selectHeaderData}>
        {data?.promo ?
          <HeaderPromoRC />
        : <>
            <HeaderRC />
            <SideMenu isOpen={isOpenSideMenu} onClose={handleLoginClick} user={data?.auth?.user} />
          </>
        }
      </HeaderModule>
      {/* @ts-expect-error FIXME Header React Model types */}
      {!!data?.chatWidget && isFirstRender && <ChatWidgetLazy config={data.chatWidget} />}
    </>
  );
};

export default compose(
  withDataConverter(headerDataConverter),
  withReduxStore(headerStore2024, {
    // NOTE: Если не указано, то, redux-store ломается
    mapPropsToState: ({ header }: any) => ({ header }),
    passThroughProps: ({ header: { common: data } }: any) => ({ data }),
  }),
)(HeaderV2);
